import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
`;

export const message = styled.div`
	width: 100%;
	padding: 1rem 2rem 2rem 2rem;

	p {
		color: ${color.interface.lightGray};
		font-size: 1.5rem;
	}
`;

export const btns = styled.div`
	width: 100%;
	padding: 2rem;
	display: flex;
	gap: 1rem;
	align-items: center;
	justify-content: flex-end;
`;

export const yesBtn = styled.button`
	all: unset;
	cursor: pointer;
	background-color: ${color.system.success};
	color: ${color.interface.white};
	padding: 0.5rem 1.5rem;
	border-radius: 3px;
	font-size: 1.4rem;
	transition: all ease 0.5s;

	:hover {
		opacity: 0.8;
		transform: scale(1.01);
	}
`;

export const noBtn = styled.button`
	all: unset;
	cursor: pointer;
	background-color: ${color.system.error};
	color: ${color.interface.white};
	padding: 0.5rem 1.5rem;
	border-radius: 3px;
	font-size: 1.4rem;
	transition: all ease 0.5s;

	:hover {
		opacity: 0.8;
		transform: scale(1.01);
	}
`;

export const line = styled.div`
	width: 100%;
	min-height: 1px;
	background-color: ${color.interface.lightGray2};
	margin: 0.5rem 0;
`;
